import {
  ContentLayout,
  ContentMain,
  ContentTip,
} from 'components/ContentLayout'
import React from 'react'
import { observer } from 'mobx-react'
import {
  Form,
  FormActions,
  FormRow,
  FormSection,
  TextInputContainer,
} from 'components/inputs'
import Button from 'components/Button'
import TeamDetailsViewModel from './TeamDetailsViewModel'
import { useBrandingSettings } from 'hooks/branding'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: TeamDetailsViewModel
}

export default observer(function TeamDetails({ vm }: Props) {
  const { corporateMode } = useBrandingSettings()

  return (
    <ContentLayout accountForLabel accountForTabBar>
      <ContentMain>
        <Form onSubmit={() => vm.saveInfo()}>
          <FormSection label="Team Details">
            <FormRow>
              <TextInputContainer
                label="Team Name"
                field="name"
                model={vm}
                disabled={vm.saveInfo.pending || !vm.canEditDetails}
                error={vm.validation.getError('name')}
              />
            </FormRow>
            <FormRow>
              <TextInputContainer
                label="Team Slug"
                readOnly
                disabled
                field="slug"
                model={vm}
              />
            </FormRow>
            <FormRow>
              <TextInputContainer
                label="Team Owner"
                model={vm}
                field={'' as never}
                readOnly
                disabled
                placeholder={vm.team.owner.member.displayName}
              />
            </FormRow>
            <FormRow>
              <TextInputContainer
                label="Team Purpose"
                field="teamPurpose"
                model={vm}
                disabled={vm.saveInfo.pending || !vm.canEditDetails}
              />
            </FormRow>
          </FormSection>
          <FormSection label="Team Address">
            <FormRow>
              <TextInputContainer
                label="Street Address"
                field="streetAddress"
                model={vm}
                disabled={vm.saveInfo.pending || !vm.canEditDetails}
              />
            </FormRow>
            <FormRow>
              <TextInputContainer
                label="City"
                field="city"
                model={vm}
                disabled={vm.saveInfo.pending || !vm.canEditDetails}
              />
            </FormRow>
            <FormRow>
              <TextInputContainer
                label="State"
                field="state"
                model={vm}
                disabled={vm.saveInfo.pending || !vm.canEditDetails}
              />
            </FormRow>
            <FormRow>
              <TextInputContainer
                label="Zip Code"
                field="zipCode"
                model={vm}
                disabled={vm.saveInfo.pending || !vm.canEditDetails}
              />
            </FormRow>
            <FormRow>
              <TextInputContainer
                label="Country"
                field="country"
                model={vm}
                disabled={vm.saveInfo.pending || !vm.canEditDetails}
              />
            </FormRow>
          </FormSection>
          {vm.canEditDetails && (
            <FormActions>
              <Button
                submit
                type="primary"
                loading={vm.saveInfo.pending}
                disabled={vm.saveInfo.pending || !vm.hasChanges}
              >
                Save
              </Button>
            </FormActions>
          )}
        </Form>
      </ContentMain>
      <ContentTip
        title="Get more out with Team Analytics!"
        illustrationUrl={
          corporateMode
            ? undefined
            : require('assets/images/img_team-analytics.svg')
        }
      >
        Are you looking to get more out of your team data? We can help.
      </ContentTip>
    </ContentLayout>
  )
})
